import { axiosInstance } from "@/api/api-client";
import { BooleanHookType } from "@/hooks/use-boolean";
import { ApiResponse } from "@/types/api-response";

const convertDateYYYYMMDD = (currentDate: Date | null): string | null => {
  if (!currentDate) {
    return null;
  }

  const year = currentDate.getFullYear();
  const month = String(currentDate.getMonth() + 1).padStart(2, '0');
  const day = String(currentDate.getDate()).padStart(2, '0');

  const formattedDate = `${year}-${month}-${day}`;

  return formattedDate;
};

const resetForm = (getValues: any, setValue: any) => {
  const keys = Object.keys(getValues);
  // eslint-disable-next-line array-callback-return
  keys.map((fieldName) => {
    if (fieldName === 'state') {
      setValue(fieldName, true);
    } else {
      // @ts-ignore
      setValue(fieldName, '');
    }
  });
};

async function generalSubmitForm({
  id,
  eventData,
  formUrl,
  onError,
  getValues,
  setValue,
  addSaveAndMore,
  onClose,
  onDone,
}: {
  id: any;
  onDone: any;
  eventData: any;
  formUrl: string;
  addSaveAndMore: any;
  getValues: any;
  setValue: any;
  onClose: any;
  onError: any;
}) {
  // eslint-disable-next-line no-useless-catch
  try {
    let res;
    if (id) {
      const url = `${formUrl}/${eventData.id}`;
      res = await axiosInstance.put(url, eventData);
    } else {
      res = await axiosInstance.post(formUrl, eventData);
    }

    const { success, message } = res.data as ApiResponse<any>;
    if (success) {
      if (addSaveAndMore.value) {
        resetForm(getValues(), setValue);
      } else {
        onClose();
      }
      console.log('url', message);
      onDone(message);
    } else if (onError) onError(message);
  } catch (error) {
    throw error;
  }
}

const generalHandleError = ({
  setSnackBarBg,
  setMessage,
  snackBar,
  text,
}: {
  setSnackBarBg: any;
  setMessage: any;
  snackBar: BooleanHookType;
  text: string;
}) => {
  setSnackBarBg('error');
  setMessage(text);
  snackBar.onTrue();
};

const generalDoneSubmit = ({
  setRefreshPage,
  setMessage,
  PageName,
  currentData,
  setCurrentData,
  fullMessage,
  snackBar,
  setSnackBarBg,
}: {
  setRefreshPage: any;
  setMessage: any;
  PageName: string;
  currentData: any;
  setCurrentData: any;
  fullMessage?: string;
  setSnackBarBg?: any;
  snackBar: any;
}) => {
  setRefreshPage((preValue: any) => !preValue);
  setMessage(fullMessage);
  setCurrentData(null);
  setSnackBarBg('success');
  snackBar.onTrue();
};

const getGender = () => [
  { label: 'Male', value: 'M' },
  { label: 'Female', value: 'F' },
];

const findGender = (value: 'F' | 'M') => {
  const gender = getGender();
  if (value) {
    return (
      gender.filter((element: { label: string; value: string }) => element.value === value)[0]
        .label || ''
    );
  }
  return gender;
};
const toFloat = (value: string) => (value ? parseFloat(value) : 0);
const toFix2 = (rawvalue: number | string) => {
  const value = toFloat(`${rawvalue}`);
  return (value > 0 ? value : 0).toFixed(2);
};

export {
  toFix2,
  toFloat,
  resetForm,
  getGender,
  findGender,
  generalSubmitForm,
  generalDoneSubmit,
  generalHandleError,
  convertDateYYYYMMDD,
};
